import React, { useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Fade } from "@mui/material";
import ConfirmationDialog from "./ModalContent/ConfirmationDialog";
import PreviousBox from "./ModalContent/PreviousBox";
import Products from "./ModalContent/Products";
import BaseUrl from "./ModalContent/BaseUrl";
import ConfirmationPrint from "./ModalContent/Confirmation.print";
import PreviouslyCreatedSerialCode from "./ModalContent/PreviouslyCreatedSerialCode";
import MasterCutterList from "./ModalContent/MasterCutterList";
import AddCutName from "./ModalContent/AddCutName";
import ViewCADMarker from "./ModalContent/ViewCADMarker";
import AddComment from "./ModalContent/AddComment";
import ViewComment from "./ModalContent/ViewComment";
import RequestApproval from "./ModalContent/RequestApproval";
import CADMarker from "./ModalContent/CADMarker";
import AddChallan from "./ModalContent/AddChallan";
import CreateBox from "./ModalContent/CreateBox";
import SKUDimensions from "./ModalContent/SKUDimensions";
import BatchDetails from "./ModalContent/BatchDetails";
import AlternateSKU from "./ModalContent/AlternateSKU";
import PortalNetInvent from "./ModalContent/PortalNetInventPopup";
import LevelDialog from "./ModalContent/LevelDialog";
import SerialCodeMessage from "./ModalContent/SerialCodeMessage";

const ModalContainer = (props) => {

  const { index } = props;
  const [width, setWidth] = useState(380);
  const [height, setHeight] = useState(300);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    right: 0,
    transform: "translate(-50%, -50%) !important",
    width: width,
    bgcolor: "background.paper",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
    p: 2,
    borderRadius: 3,
    border: "1px solid #C7C7C7",
    height: index === 6 ? "auto" : height,
    overflowX: "hidden",
    overflowY:
      index === 0
        ? "auto"
        : index === 6 ||
          index === 13 ||
          index === 15 ||
          index === 17 ||
          index === 19
        ? "hidden"
        : "",
    outline: "none",
  };

  const backdropStyle = {
    // Add backdrop filter for blur
    backdropFilter: "blur(3px)",
  };

  const componentMap = {
    0: (
      <ConfirmationDialog
        close={props.closeModal}
        title={props.title}
        description={props.description}
        inventory_id={props.inventory_id}
        handleRefresh={props.handleRefresh}
      />
    ),
    1: (
      <PreviousBox close={props.closeModal} inventory_id={props.inventory_id} />
    ),
    2: (
      <Products
        close={props.closeModal}
        inventory_id={props.inventory_id}
        box_id={props.box_id}
      />
    ),
    3: <BaseUrl close={props.closeModal} setCurrentUri={props.setCurrentUri} />,
    4: (
      <ConfirmationPrint
        close={props.closeModal}
        inventory_id={props.inventory_id}
        token={props.token}
        inventory_details={props.inventory_details}
        // handleMRP={props.handleMRP}
      />
    ),
    5: (
      <PreviouslyCreatedSerialCode
        close={props.closeModal}
        previously__scanned__code={props.previously__scanned__code}
        code={props.code}
        handleForcedCreate={props.handleForcedCreate}
        handleDownloadLabel={props.handleDownloadLabel}
      />
    ),
    6: (
      <MasterCutterList
        close={props.closeModal}
        handleCutterSelect={props.handleCutterSelect}
        orderId={props.orderId}
        IsPicked={props.IsPicked}
      />
    ),
    7: (
      <AddCutName
        close={props.closeModal}
        title="Add Cut Name"
        product_group_id={props.product_group_id}
        fetchData={props.fetchFabricEstData}
      />
    ),
    8: (
      <ViewCADMarker
        close={props.closeModal}
        title="View CAD Marker"
        cut_id={props.cut_id}
      />
    ),
    9: (
      <AddComment
        close={props.closeModal}
        title={props.title}
        order_id={props.order_id}
      />
    ),
    10: (
      <ViewComment
        close={props.closeModal}
        title="View Comments"
        order_id={props.order_id}
      />
    ),
    11: (
      <RequestApproval
        close={props.closeModal}
        title="Request for Approval"
        cut_id={props.cut_id}
        order_id={props.order_id}
        fetchData={props.fetchFabricEstData}
      />
    ),
    12: (
      <CADMarker
        close={props.closeModal}
        title={props.title}
        cut_id={props.cut_id}
      />
    ),
    13: (
      <AddChallan
        close={props.closeModal}
        manufactureOrderId={props.manufactureOrderId}
      />
    ),
    14: (
      <CreateBox
        close={props.closeModal}
        inventory_id={props.inventory_id}
        sub_location_id={props.sub_location_id}
        has_single_sku={props.has_single_sku}
        handleBoxCreated={props.handleBoxCreated}
        from_Location_id={props.from_Location_id}
        to_Location_id={props.to_Location_id}
        party_id={props.party_id}
      />
    ),
    15: <SKUDimensions close={props.closeModal} />,
    16: <BatchDetails close={props.closeModal} batch_id={props.batch_id} />,
    17: (
      <AlternateSKU
        close={props.closeModal}
        alternate_sku={props.alternate__sku_details}
      />
    ),
    18: (
      <AlternateSKU
        close={props.closeModal}
        alternate_sku={props.alternate__sku_details}
      />
    ),
    19: (
      <PortalNetInvent
        close={props.closeModal}
        sync_number={props.sync_number}
        key_id={props.key_id}
        activeProductListening={props.activeProductListening}
      />
    ),
    20: (
      <LevelDialog
        close={props.closeModal}
        key_id={props.key_id}
      />
    ),
    21: (
      <SerialCodeMessage
        close={props.closeModal}
        showMessage={props.showMessage}
        handleRefresh={props.handleRefresh}
      />
    ),
    
  };

  useEffect(() => {
    if (index === 0) {
      setWidth(402);
      setHeight(234);
    }

    if (
      (index === 0 && props.title === "Create Box") ||
      props.title === "Alert"
    ) {
      setHeight(200);
    }
    if (index === 4) {
      setWidth(402);
      setHeight(230);
    }
    if (index === 1 || index === 2 || index === 5) {
      setWidth(930);
      setHeight(380);
    }
    if (index === 6) {
      setWidth(402);
      setHeight(450);
    }
    if (index === 9 || index === 13) {
      setWidth(550);
      setHeight(460);
    }
    if (index === 12) {
      setWidth(500);
      setHeight(450);
    }
    if (index === 14) {
      setWidth(350);
      setHeight(280);
    }
    if (index === 15) {
      setWidth(350);
      setHeight(520);
    }
    if (index === 21) {
      setWidth(350);
      setHeight(450);
    }
    if (index === 16 || index === 20) {
      setWidth(550);
      setHeight(150);
    }
    if (index === 17 || index === 19) {
      setWidth(650);
      setHeight(320);
    }
  }, [index, props.title]);

  return (
    <Modal
      open={props.Isopen}
      onClose={props.closeModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        style: backdropStyle,
      }}
      className="modal-container"
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      style={{ overflow: "scroll" }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={props.Isopen}>
        <Box sx={style}>{componentMap[index]}</Box>
      </Fade>
    </Modal>
  );
};

export default ModalContainer;

export const HeadingTitle = (props) => {
  // console.log(props);
  return (
    <>
      <div
        className={`header-cross-title ${
          props.center ? "center-text" : "left-align-text"
        }`}
      >
        <Typography
          style={{
            color: "#1C1C1C",
          }}
          id="modal-modal-title"
          variant="h6"
          component="h2"
          className={`${!props.center && "left-text"}`}
        >
          {props.title}
        </Typography>
        <div className="bg-cross" onClick={props.closeModal}>
          {/* <img src={CrossIcon} alt="" /> */}
          <CloseIcon className="cross-icon-col" />
        </div>
      </div>
      {props.desc && (
        <p
          style={{ marginTop: props.descTop ? "5px" : "" }}
          className="description-text"
        >
          {props.desc}
        </p>
      )}
    </>
  );
};
